import { IconText } from '@delmonicos/shared-design-system-react/src/components/icon-text/icon-text';
import {
  TextInput,
  TextInputProps,
} from '@delmonicos/shared-design-system-react/src/components/input/text-input';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { useTranslation } from 'react-i18next';

interface EmspBoTariffIdFilterControllerProps
  extends Pick<TextInputProps, 'value' | 'onChange'> {}

export const EmspBoTariffIdFilterController = ({
  value,
  onChange,
}: EmspBoTariffIdFilterControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // DATA FETCHING /////////////////////////////////////////////////////////////

  // Nothing to do

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Stack direction="column" gap={GapEnum.M}>
      <IconText
        iconName="tool-02"
        text={t('delmonicos-shared-sdk.inputs-get-tariff.tariff-id')}
      />
      <TextInput value={value} onChange={onChange} />
    </Stack>
  );
};
